import { buildGraphqlQuery } from '@ztechapps/common.utils'

export const queries = buildGraphqlQuery(
  'Blog',
  `_id
  updatedAt
  status
  title
  slug
  summary
  remarks
  tags
  cover
  `
)
